import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  Alert,
  AlertPropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/alerts.scss';

export type NcAlertT = React.FC<AlertPropsT>;

export const NcAlert: NcAlertT = ({
  children,
  className,
  ...props
}) => {
  const classNames = mergeClassNameStrings('nc-alert', className);

  return (
    <Alert className={classNames} {...props}>
      {children}
    </Alert>
  );
};
